import { useContext } from 'react';

import { UseOpenCloseReturn } from '~/core/hooks/useOpenClose';
import {
  ApplicationContext,
  DocumentDetailsViewActionContext,
} from '../../../../../Layout.component';

export const useGrantorSearchModalApi = (): UseOpenCloseReturn => {
  const { actionContexts } = useContext(ApplicationContext);

  const {
    action: { key },
  } = useContext(DocumentDetailsViewActionContext);

  return actionContexts[key].modal;
};
